import React, { useEffect, useState, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Spin, Row, Col, Avatar } from 'antd'
import Flex from 'components/Flex'
import AvatarImage from 'components/Avatar'
import CallIcon from 'components/icons/CallIcon'
import EditIcon from 'components/icons/EditIcon'
import MailIcon from 'components/icons/MailIcon'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { getStudentDataById, getPendingDataByStudentId, getTPOApprovalConfig, updateStudentData, getStudentResumeData, upsertStudentResume } from '../../actions'
import { getStudentPendingData } from '../../../Students/actions'
import { getListOfCountries, getListOfState, getListOfCity, getCities, searchAPI } from '../../../OnBoarding/actions'
import { resumeBulkDownload } from '../../../Placement/action'
import { singlePdf } from 'utils/downloadFile'
//import { getCities } from '../../../Roles/actions'
import EducationSection from './Style/EducationSection'
import ProjectSection from './Style/ProjectDetailsSection'
import InternshipSection from './Style/InternshipSection'
import WorkExpSection from './Style/WorkExpSection'
import AwardsSection from './Style/AwardsSection'
import TrainingSection from './Style/TrainingSection'
import AdditionalInfo from './Style/AdditionalInfo'
import CurrentlyPursuing from './Sections/CurrentlyPursuing'
import SocialMediaLinks from './Sections/SocialMediaLinks'
import ResumeSection from './Sections/ResumeSection'
import ResumeDownload from './Sections/ResumeDownload'
import Button from 'components/Button'
import { SetDefaultPill } from './ResumeStyle'
import ProjectDrawer from './DrawerComponents/ProjectDetails/ProjectDetails/ProjectDrawer'
import EducationalDrawer from './DrawerComponents/EducationDetails/EducationalDrawer'
import InternshipDrawer from './DrawerComponents/ProjectDetails/ProjectDetails/InternshipDrawer'
import WorkExperienceDrawer from './DrawerComponents/ProjectDetails/ProjectDetails/WorkExperienceDrawer'
import CourseTrainingDrawer from './DrawerComponents/ProjectDetails/ProjectDetails/CourseTraining'
import AdditionDrawer from './DrawerComponents/AdditionalDetails/AdditionDrawer'
import SocialMediaDrawer from './DrawerComponents/AdditionalDetails/SocialMediaDrawer'
import AwardsDrawer from './DrawerComponents/AwardDetails/AwardsDrawer'
import LeftArrow from 'components/icons/LeftArrow.js'
import DefaultResumeDrawer from './DrawerComponents/DefaultResumeDrawer'
import UploadResumeDrawer from './DrawerComponents/UploadResumeDrawer'
import ObjectiveDrawer from './DrawerComponents/ObjectiveDrawer'
import {
  SectionWrapper,
  OuterDiv,
  TopHeader,
  TopHeading,
  RowwithPadding,
  LeftCol,
  RightDiv,
  HeaderFlexOne,
  InfoSection,
  StudentName,
  CollegeName,
  SectionNavMenu,
  MenuItem,
  MainHeading,
  GeneralEditIcon,
  StyledP,
  EditorContent,
  StyledDivider,
  SubFLex,
  EditIconWrapper,
} from './style'
import styled from 'styled-components'

const BackButtonWrapper = styled.div`
  // padding: 20px 100px 10px 100px;
  background: #f5f6f8;
  margin-bottom: 1%;
  
  @media only screen and (max-device-width: 767px) {
    padding: 10px;
  }
`

const BackButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #3249d7;
  font-weight: 500;
  
  &:hover {
    opacity: 0.8;
  }
`

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`

const StudentResume = () => {
  const { studentId } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [studentData, setStudentData] = useState(null)
  const [pendingData, setPendingData] = useState(null)
  const [studentPendingData, setStudentPendingData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [tpoConfig, setTpoConfig] = useState(null)
  const [resumeFiles, setResumeFiles] = useState([])
  const [loadingResumes, setLoadingResumes] = useState(true)
  const [defaultResumeId, setDefaultResumeId] = useState('PIL')
  const [resumeError, setResumeError] = useState('')
  const [projectDrawer, setProjectDrawer] = useState(false)
  const [educationDrawer, setEducationDrawer] = useState(false)
  const [internshipDrawer, setInternshipDrawer] = useState(false)
  const [workExpDrawer, setWorkExpDrawer] = useState(false)
  const [trainingDrawer, setTrainingDrawer] = useState(false)
  const [awardsDrawer, setAwardsDrawer] = useState(false)
  const [additionalInfoDrawer, setAdditionalInfoDrawer] = useState(false)
  const [socialMediaDrawer, setSocialMediaDrawer] = useState(false)
  const [objectiveDrawer, setObjectiveDrawer] = useState(false)
  const [defaultDrawer, setDefaultDrawer] = useState(false)
  const [uploadDrawer, setUploadDrawer] = useState(false)

  const instituteName = useSelector(state => state?.studentData?.campusDetails)
  const countryList = useSelector(state => state?.institute?.onboarding?.listOfCountry || [])
  const object = useRef()
  const education = useRef()
  const project = useRef()
  const internship = useRef()
  const course = useRef()
  const workexp = useRef()
  const award = useRef()

  const transformPendingData = (pendingRequests) => {
    if (!pendingRequests?.requests || !Array.isArray(pendingRequests.requests)) {
      return pendingRequests
    }

    const transformed = {
      ...pendingRequests,
      resume: {
        courses: [],
        workExperience: [],
        projects: [],
        internships: [],
        awards: []
      },
      studentPersonalProfile: {},
      admin: {},
      resumes: [],
    }

    pendingRequests.requests.forEach(request => {
      if (request.status !== 'PENDING') return

      const fieldName = request.fieldName

      if (fieldName === 'certifications' && request.itemId && request.isNewItem) {
        const certificationData = request.requestedData
        const certItem = {
          _tempId: request.itemId,
          _requestId: request.id,
          _pendingFields: {},
          _isNew: true,
          ...certificationData,
          id: certificationData.temp_id || request.itemId
        }
        transformed.resume.courses.push(certItem)
        return
      }

      if (fieldName === 'cv' && request.isNewItem) {
        if (!transformed.resumes) {
          transformed.resumes = []
        }

        const resumeData = request.requestedData

        transformed.resumes.push({
          _itemId: request.itemId,
          _requestId: request.id,
          _status: request.status,
          ...resumeData
        })

        return
      }

      if (fieldName === 'projects' && request.itemId && request.isNewItem) {
        const projectData = request.requestedData
        const projectItem = {
          _tempId: request.itemId,
          _requestId: request.id,
          _pendingFields: {},
          _isNew: true,
          ...projectData,
          id: projectData.temp_id || request.itemId
        }
        transformed.resume.projects.push(projectItem)
        return
      }

      if (fieldName === 'internships' && request.itemId && request.isNewItem) {
        const internshipData = request.requestedData
        const internshipItem = {
          _tempId: request.itemId,
          _requestId: request.id,
          _pendingFields: {},
          _isNew: true,
          ...internshipData,
          id: internshipData.temp_id || request.itemId
        }
        transformed.resume.internships.push(internshipItem)
        return
      }

      if (fieldName === 'workExperience' && request.itemId && request.isNewItem) {
        const workExpData = request.requestedData
        const workExpItem = {
          _tempId: request.itemId,
          _requestId: request.id,
          _pendingFields: {},
          _isNew: true,
          ...workExpData,
          id: workExpData.temp_id || request.itemId
        }
        transformed.resume.workExperience.push(workExpItem)
        return
      }

      if (fieldName === 'awards' && request.itemId && request.isNewItem) {
        const awardData = request.requestedData
        const awardItem = {
          _tempId: request.itemId,
          _requestId: request.id,
          _pendingFields: {},
          _isNew: true,
          ...awardData,
          id: awardData.temp_id || request.itemId
        }
        transformed.resume.awards.push(awardItem)
        return
      }

      if ((fieldName === 'education' || fieldName === 'otherEducation') && request.itemId && request.isNewItem) {
        if (!transformed.resume.education) {
          transformed.resume.education = []
        }
        const educationData = request.requestedData
        const educationItem = {
          _tempId: request.itemId,
          _requestId: request.id,
          _pendingFields: {},
          _isNew: true,
          ...educationData,
          id: educationData.temp_id || request.itemId
        }
        transformed.resume.education.push(educationItem)
        return
      }

      if (fieldName === 'internships.certifications' && request.itemId) {
        let internshipItem = transformed.resume.internships.find(i => i.id === request.itemId || i._tempId === request.itemId)
        if (!internshipItem) {
          internshipItem = {
            _tempId: request.itemId,
            _requestId: request.id,
            _pendingFields: {},
            certificate: request.requestedData
          }
          transformed.resume.internships.push(internshipItem)
        } else {
          internshipItem.certificate = request.requestedData
        }
        internshipItem._pendingFields['certificate'] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status,
          _requestId: request.id
        }
        return
      }

      if (fieldName === 'projects.certifications' && request.itemId) {
        let projectItem = transformed.resume.projects.find(p => p.id === request.itemId || p._tempId === request.itemId)
        if (!projectItem) {
          projectItem = {
            _tempId: request.itemId,
            _requestId: request.id,
            _pendingFields: {},
            certificate: request.requestedData
          }
          transformed.resume.projects.push(projectItem)
        } else {
          projectItem.certificate = request.requestedData
        }
        projectItem._pendingFields['certificate'] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status,
          _requestId: request.id
        }
        return
      }

      if (fieldName === 'workExperience.certifications' && request.itemId) {
        let workExpItem = transformed.resume.workExperience.find(w => w.id === request.itemId || w._tempId === request.itemId)
        if (!workExpItem) {
          workExpItem = {
            _tempId: request.itemId,
            _requestId: request.id,
            _pendingFields: {},
            certificate: request.requestedData
          }
          transformed.resume.workExperience.push(workExpItem)
        } else {
          workExpItem.certificate = request.requestedData
        }
        workExpItem._pendingFields['certificate'] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status,
          _requestId: request.id
        }
        return
      }

      if (fieldName === 'education.markSheetUrl' && request.itemId) {
        let educationItem = transformed.resume.education?.find?.(e => e.id === request.itemId || e._tempId === request.itemId)
        if (!transformed.resume.education) {
          transformed.resume.education = []
        }
        if (!educationItem) {
          educationItem = {
            _tempId: request.itemId,
            _requestId: request.id,
            _pendingFields: {},
            markSheetUrl: request.requestedData
          }
          transformed.resume.education.push(educationItem)
        } else {
          educationItem.markSheetUrl = request.requestedData
        }
        educationItem._pendingFields['markSheetUrl'] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status,
          _requestId: request.id
        }
        return
      }

      if (fieldName?.startsWith('certifications.') && request.itemId) {
        let courseItem = transformed.resume.courses.find(c => c.id === request.itemId)
        if (!courseItem) {
          courseItem = { id: request.itemId, _requestId: request.id, _pendingFields: {} }
          transformed.resume.courses.push(courseItem)
        }
        const field = fieldName.replace('certifications.', '')
        courseItem[field] = request.requestedData
        courseItem._pendingFields[field] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status
        }
      } else if (fieldName?.startsWith('resume.courses.') && request.itemId) {
        let courseItem = transformed.resume.courses.find(c => c.id === request.itemId)
        if (!courseItem) {
          courseItem = { id: request.itemId, _requestId: request.id, _pendingFields: {} }
          transformed.resume.courses.push(courseItem)
        }
        const field = fieldName.replace('resume.courses.', '')
        courseItem[field] = request.requestedData
        courseItem._pendingFields[field] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status
        }
      } else if (fieldName?.startsWith('resume.workExperience.') && request.itemId) {
        let workExpItem = transformed.resume.workExperience.find(w => w.id === request.itemId)
        if (!workExpItem) {
          workExpItem = { id: request.itemId, _requestId: request.id, _pendingFields: {} }
          transformed.resume.workExperience.push(workExpItem)
        }
        const field = fieldName.replace('resume.workExperience.', '')
        workExpItem[field] = request.requestedData
        workExpItem._pendingFields[field] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status
        }
      } else if (fieldName?.startsWith('resume.projects.') && request.itemId) {
        let projectItem = transformed.resume.projects.find(p => p.id === request.itemId)
        if (!projectItem) {
          projectItem = { id: request.itemId, _requestId: request.id, _pendingFields: {} }
          transformed.resume.projects.push(projectItem)
        }
        const field = fieldName.replace('resume.projects.', '')
        projectItem[field] = request.requestedData
        projectItem._pendingFields[field] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status
        }
      } else if (fieldName?.startsWith('resume.internships.') && request.itemId) {
        let internshipItem = transformed.resume.internships.find(i => i.id === request.itemId)
        if (!internshipItem) {
          internshipItem = { id: request.itemId, _requestId: request.id, _pendingFields: {} }
          transformed.resume.internships.push(internshipItem)
        }
        const field = fieldName.replace('resume.internships.', '')
        internshipItem[field] = request.requestedData
        internshipItem._pendingFields[field] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status
        }
      } else if (fieldName?.startsWith('resume.awards.') && request.itemId) {
        let awardItem = transformed.resume.awards.find(a => a.id === request.itemId)
        if (!awardItem) {
          awardItem = { id: request.itemId, _requestId: request.id, _pendingFields: {} }
          transformed.resume.awards.push(awardItem)
        }
        const field = fieldName.replace('resume.awards.', '')
        awardItem[field] = request.requestedData
        awardItem._pendingFields[field] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status
        }
      } else if (fieldName?.startsWith('workExperience.') && request.itemId) {
        let workExpItem = transformed.resume.workExperience.find(w => w.id === request.itemId)
        if (!workExpItem) {
          workExpItem = { id: request.itemId, _requestId: request.id, _pendingFields: {} }
          transformed.resume.workExperience.push(workExpItem)
        }
        const field = fieldName.replace('workExperience.', '')
        workExpItem[field] = request.requestedData
        workExpItem._pendingFields[field] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status
        }
      } else if (fieldName?.startsWith('internships.') && request.itemId) {
        let internshipItem = transformed.resume.internships.find(i => i.id === request.itemId)
        if (!internshipItem) {
          internshipItem = { id: request.itemId, _requestId: request.id, _pendingFields: {} }
          transformed.resume.internships.push(internshipItem)
        }
        const field = fieldName.replace('internships.', '')
        internshipItem[field] = request.requestedData
        internshipItem._pendingFields[field] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status
        }
      } else if (fieldName?.startsWith('projects.') && request.itemId) {
        let projectItem = transformed.resume.projects.find(p => p.id === request.itemId)
        if (!projectItem) {
          projectItem = { id: request.itemId, _requestId: request.id, _pendingFields: {} }
          transformed.resume.projects.push(projectItem)
        }
        const field = fieldName.replace('projects.', '')
        projectItem[field] = request.requestedData
        projectItem._pendingFields[field] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status
        }
      }
    })

    // Handle currentCourse field updates
    pendingRequests.requests.forEach(request => {
      if (request.status !== 'PENDING') return
      
      const fieldName = request.fieldName
      if (fieldName?.startsWith('currentCourse.') && !request.itemId) {
        const field = fieldName.replace('currentCourse.', '')
        
        if (!transformed.currentCourse) {
          transformed.currentCourse = {}
        }
        
        if (!transformed.currentCourse._pendingFields) {
          transformed.currentCourse._pendingFields = {}
        }
        
        // Handle nested university object
        if (field === 'university' && typeof request.requestedData === 'object' && request.requestedData !== null) {
          transformed.currentCourse.university = request.requestedData.university
          transformed.currentCourse.universityId = request.requestedData.universityId
          transformed.currentCourse._pendingFields.university = {
            value: request.requestedData.university,
            originalValue: request.originalData?.university,
            status: request.status,
            _requestId: request.id
          }
          transformed.currentCourse._pendingFields.universityId = {
            value: request.requestedData.universityId,
            originalValue: request.originalData?.universityId,
            status: request.status,
            _requestId: request.id
          }
        } else {
          transformed.currentCourse[field] = request.requestedData
          transformed.currentCourse._pendingFields[field] = {
            value: request.requestedData,
            originalValue: request.originalData,
            status: request.status,
            _requestId: request.id
          }
        }
      }
    })

    return transformed
  }

  const fetchData = async () => {
    setLoading(true)
    try {
      const student = await dispatch(getStudentDataById(studentId))
      setStudentData(student)

      const pending = await dispatch(getPendingDataByStudentId(studentId))
      const transformedPending = transformPendingData(pending)
      setPendingData(transformedPending)

      const studentPending = await dispatch(getStudentPendingData(studentId))
      setStudentPendingData(studentPending)

      const config = await dispatch(getTPOApprovalConfig())
      setTpoConfig(config)

    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setLoading(false)
    }
  }
  const mapApiResumesToUi = (backendResumes = []) =>
    backendResumes.map((r) => ({
      id: r.id,
      name: r.resumeName,
      type: r.resumeType === "SYSTEM" ? "SYSTEM" : "UPLOADED",
      url: r.fileUrl?.url || "",
      uploadedOn: new Date(r.createdAt).toLocaleDateString("en-GB"),
      isDefault: r.isDefault,
      fileFormat: r.fileFormat?.toLowerCase() || null,
      _raw: r,
    }))

  const mapPendingResumesToUi = (pendingResumes = []) =>
    pendingResumes.map(r => ({
      id: r._itemId,
      name: r.resumeName,
      type: r.resumeType,
      url: r.fileUrl?.url || "",
      uploadedOn: new Date().toLocaleDateString("en-GB"),
      isDefault: false,
      isPending: r._status === "PENDING",
      fileFormat: r.fileFormat || r.resumeName?.split(".").pop()?.toLowerCase() || "pdf",
      _raw: r,
    }))

  const fetchResumeData = async () => {
    try {
      setLoadingResumes(true)
      const result = await dispatch(getStudentResumeData(studentId))

      const approvedUi = mapApiResumesToUi(result?.resumes || [])
      const pendingUi = mapPendingResumesToUi(pendingData?.resumes || [])

      setResumeFiles([...approvedUi, ...pendingUi])

      const def = approvedUi.find(r => r.isDefault)
      setDefaultResumeId(def ? def.id : "PIL")
    } catch (error) {
      console.error('Error fetching resume data:', error)
    } finally {
      setLoadingResumes(false)
    }
  }

  // Wrapper functions for location data
  const handleGetListOfCountries = (search, isPaginate, setLoading) => {
    return dispatch(getListOfCountries(search, isPaginate, setLoading))
  }

  const handleGetListOfState = (countryId, search, isPaginate, setLoadingState) => {
    return dispatch(getListOfState(countryId, search, isPaginate, setLoadingState))
  }

  const handleGetListOfCity = (countryId, stateId, search, isPaginate, setLoadingCity) => {
    return dispatch(getListOfCity(countryId, stateId, search, isPaginate, setLoadingCity))
  }

  const handleGetCities = (query) => {
    return dispatch(getCities(query))
  }

  const handleSearchAPI = (type, search, payload) => {
    return dispatch(searchAPI(type, search, payload))
  }

  const handleResumeUpload = (event) => {
    const file = event.target.files[0]
    if (!file) return

    const allowedTypes = ['pdf']
    const fileExt = file.name.split('.').pop().toLowerCase()

    if (!allowedTypes.includes(fileExt)) {
      setResumeError('Please upload valid file format')
      event.target.value = ''
      return
    }

    const MAX_SIZE = 5 * 1024 * 1024
    if (file.size > MAX_SIZE) {
      setResumeError('File size should not exceed 5 MB')
      return
    }

    const isDuplicate = resumeFiles.some(
      (item) => item.name.toLowerCase() === file.name.toLowerCase()
    )

    if (isDuplicate) {
      setResumeError('A resume with the same file name already exists')
      return
    }

    if (resumeFiles.length >= 5) {
      setResumeError('Max no. of files uploaded')
      event.target.value = ''
      return
    }

    setResumeError('')

    const newFile = {
      id: Date.now(),
      file,
      name: file.name,
      type: fileExt.toUpperCase(),
      uploadedOn: new Date().toLocaleDateString('en-GB'),
      url: URL.createObjectURL(file),
      fileFormat: fileExt,
    }

    setResumeFiles(prev => [...prev, newFile])
    event.target.value = ''
  }

  const deleteResumeFile = async (id) => {
    const updatedFiles = [...resumeFiles]
    const fileToDelete = updatedFiles.find(f => f.id === id)

    if (!fileToDelete) {
      console.warn('File not found for deletion:', id)
      return
    }

    const filteredFiles = updatedFiles.filter((item) => item.id !== id)
    setResumeFiles(filteredFiles)

    let newDefaultId = defaultResumeId
    if (defaultResumeId === id) {
      newDefaultId = filteredFiles.length > 0
        ? filteredFiles[filteredFiles.length - 1].id
        : 'PIL'
      setDefaultResumeId(newDefaultId)
    }

    const payload = {
      isDirectTPOUpdate: true,
      instituteCampusId: instituteName?.id,
      resumes: filteredFiles.map((f) => {
        const raw = f._raw || {}
        const isSystem = raw.resumeType === "SYSTEM"

        return {
          id: raw.id || null,
          resumeName: f.name,
          resumeType: raw.resumeType || "UPLOADED",
          fileUrl: isSystem
            ? { url: "", type: "SYSTEM_GENERATED" }
            : raw.fileUrl || { url: f.url },
          isDefault: f.id === newDefaultId,
          fileSize: isSystem ? null : raw.fileSize || f.fileSize || null,
          fileFormat: raw.fileFormat || (f.name?.split(".").pop()?.toLowerCase() || null),
        }
      }),
    }

    try {
      await dispatch(upsertStudentResume(studentId, payload))
      await fetchResumeData()
      await fetchData()
    } catch (error) {
      console.error("Failed to delete file:", error)
      setResumeFiles(updatedFiles)
      setDefaultResumeId(defaultResumeId)
    }
  }

  const downloadResumeFile = (item) => {
    const link = document.createElement('a')
    link.href = item.url
    link.download = item.name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleStudentResumeDownload = async () => {
    try {
      const payload = {
        email: studentData?.admin?.email,
        instName: studentData?.instituteCampusName,
        state: studentData?.currentCourse?.state,
        city: studentData?.currentCourse?.city,
        user: `${studentData?.admin?.first_name} ${studentData?.admin?.last_name}`,
        studentIds: [[studentData?.id]],
      }
      const response = await dispatch(resumeBulkDownload(payload))
      const studentName = `${studentData?.admin?.first_name} ${studentData?.admin?.last_name}`
      if (response?.data) {
        await singlePdf(response, studentName)
      }
    } catch (err) {
      console.error('Resume download failed:', err)
    }
  }

  const handleUploadDrawerSave = async (files, selectedId) => {
    const resumesPayload = files.map(f => {
      const raw = f._raw || {}
      const isSystem = raw.resumeType === "SYSTEM"

      return {
        id: raw.id || null,
        resumeName: f.name,
        resumeType: raw.resumeType || "UPLOADED",
        fileUrl: isSystem
          ? { url: "", type: "SYSTEM_GENERATED" }
          : raw.fileUrl || { url: f.url },
        isDefault: f.id === selectedId,
        fileSize: isSystem
          ? null
          : raw.fileSize || f.file?.size || null,
        fileFormat: raw.fileFormat || (f.name?.split(".").pop()?.toLowerCase() || null),
      }
    })

    const payload = {
      resumes: resumesPayload,
      isDirectTPOUpdate: true,
      instituteCampusId: instituteName?.id,
    }

    await dispatch(upsertStudentResume(studentId, payload))
    await fetchResumeData()
    await fetchData()
  }

  const handleSetDefaultResume = async (selectedId) => {
    const payload = {
      isDirectTPOUpdate: true,
      instituteCampusId: instituteName?.id,
      resumes: resumeFiles.map((f) => {
        const raw = f._raw || {}
        const isSystem = raw.resumeType === "SYSTEM"

        return {
          id: raw.id || null,
          resumeName: f.name,
          resumeType: raw.resumeType || "UPLOADED",
          fileUrl: isSystem
            ? { url: "", type: "SYSTEM_GENERATED" }
            : raw.fileUrl || { url: f.url },
          isDefault: f.id === selectedId,
          fileSize: isSystem ? null : raw.fileSize || f.fileSize || null,
          fileFormat: raw.fileFormat || (f.name?.split(".").pop()?.toLowerCase() || null),
        }
      }),
    }

    await dispatch(upsertStudentResume(studentId, payload))
    await fetchResumeData()
  }

  useEffect(() => {
    if (studentId) {
      fetchData()
      fetchResumeData()
    }
  }, [studentId])

  useEffect(() => {
    if (studentId && pendingData) {
      fetchResumeData()
    }
  }, [pendingData])

  const handleBack = () => {
    navigate(-1)
  }

  const ClickedObject = () => {
    object.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const ClickedEdu = () => {
    education.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const ClickedProject = () => {
    project.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const ClickedCourse = () => {
    course.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const ClickedAward = () => {
    award.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const ClickedWork = () => {
    workexp.current?.scrollIntoView({ behavior: 'smooth' })
  }

  if (loading) {
    return (
      <SectionWrapper column>
        <LoadingWrapper>
          <Spin size="large" />
        </LoadingWrapper>
      </SectionWrapper>
    )
  }

  if (!studentData) {
    return (
      <SectionWrapper column>
        <OuterDiv>
          <TopHeader row spaceBetween alignCenter>
            <Flex>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div
                  onClick={handleBack}
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                >
                  <LeftArrow />
                </div>
                <TopHeading>Student Resume</TopHeading>
              </div>
            </Flex>
          </TopHeader>
          <RowwithPadding>
            <p>Student data not found.</p>
          </RowwithPadding>
        </OuterDiv>
      </SectionWrapper>
    )
  }

  return (
    <>
      {/* <BackButtonWrapper>
        <BackButton onClick={handleBack}>
          <ArrowLeftOutlined />
          Back to Profile Approval Listing
        </BackButton>
      </BackButtonWrapper> */}

      <SectionWrapper column>
        <OuterDiv>
          <TopHeader row spaceBetween alignCenter>
            <Flex>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div
                  onClick={handleBack}
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                >
                  <LeftArrow />
                </div>
                <TopHeading>Student Resume</TopHeading>
              </div>
            </Flex>
            <Flex>
              {/* <ResumeDownload studentData={studentData}> */}
                <Button.Primary
                  text={'Download Resume'}
                  height={'38px'}
                  width={'180px'}
                  onClick={handleStudentResumeDownload }
                />
              {/* </ResumeDownload> */}
            </Flex>
          </TopHeader>

          <RowwithPadding>
            <LeftCol span={16}>
              <HeaderFlexOne spaceBetween>
                <Flex>
                  <AvatarImage
                    background
                    src={studentData?.profileUrl}
                    IconName={studentData?.admin?.first_name?.[0] || 'S'}
                    size={90}
                    font={18}
                  />

                  <InfoSection column center>
                    <StudentName>
                      {studentData?.admin?.first_name || ''} {studentData?.admin?.last_name || ''}
                    </StudentName>
                    <CollegeName>
                      <MailIcon /> {studentData?.admin?.email || ''}
                    </CollegeName>
                    <CollegeName>
                      <CallIcon /> {studentData?.admin?.country_code || ''}-
                      {studentData?.admin?.phone_number || ''}
                    </CollegeName>
                  </InfoSection>
                </Flex>
              </HeaderFlexOne>

              <SectionNavMenu mode="horizontal" defaultSelectedKeys={['Objective']}>
                <MenuItem key="Objective" onClick={ClickedObject}>
                  Objective
                </MenuItem>
                <MenuItem key="Education" onClick={ClickedEdu}>
                  Education
                </MenuItem>
                <MenuItem key="Project" onClick={ClickedProject}>
                  Projects & Internships
                </MenuItem>
                <MenuItem key="Courses" onClick={ClickedCourse}>
                  Certification
                </MenuItem>
                <MenuItem key="Awards" onClick={ClickedAward}>
                  Awards
                </MenuItem>
                <MenuItem key="Work" onClick={ClickedWork}>
                  Work Experience
                </MenuItem>
              </SectionNavMenu>

              {/* Objective */}
              <Row ref={object}>
                <Col span={20}>
                  <MainHeading paddingTop="25px" marginBottom="10px">
                    Objective
                  </MainHeading>
                </Col>
                <Col span={4}>
                  <GeneralEditIcon>
                    <Avatar
                      onClick={() => setObjectiveDrawer(true)}
                      src={<EditIcon className="iconStyle" />}
                    />
                  </GeneralEditIcon>
                </Col>
              </Row>
              <StyledP>
                <EditorContent
                  dangerouslySetInnerHTML={{
                    __html: studentData?.resume?.objective || '',
                  }}
                />
              </StyledP>

              <StyledDivider />

              {/* Education */}
              <Row ref={education}>
                <Col span={20}>
                  <MainHeading>Education</MainHeading>
                </Col>
                <Col span={4}>
                  <EditIconWrapper onClick={() => setEducationDrawer(true)}>
                    <EditIcon />
                  </EditIconWrapper>
                </Col>
              </Row>
              <EducationSection
                studentDetails={studentData}
                instituteName={instituteName}
                pendingData={studentPendingData}
                frozenFields={{}}
              />

              <StyledDivider />

              {/* Projects */}
              <Row ref={project}>
                <Col span={20}>
                  <MainHeading>Projects</MainHeading>
                </Col>
                <Col span={4}>
                  <EditIconWrapper onClick={() => setProjectDrawer(true)}>
                    <EditIcon />
                  </EditIconWrapper>
                </Col>
              </Row>
              <SubFLex column gap="25px">
                <ProjectSection studentDetails={studentData} pendingData={pendingData} />
              </SubFLex>

              <StyledDivider />

              {/* Internships */}
              <Row>
                <Col span={20}>
                  <MainHeading>Internship</MainHeading>
                </Col>
                <Col span={4}>
                  <EditIconWrapper onClick={() => setInternshipDrawer(true)}>
                    <EditIcon />
                  </EditIconWrapper>
                </Col>
              </Row>
              <SubFLex column gap="25px">
                <InternshipSection studentDetails={studentData} pendingData={pendingData} />
              </SubFLex>

              <StyledDivider />

              {/* Certification */}
              <Row ref={course}>
                <Col span={20}>
                  <MainHeading>Certification</MainHeading>
                </Col>
                <Col span={4}>
                  <EditIconWrapper onClick={() => setTrainingDrawer(true)}>
                    <EditIcon />
                  </EditIconWrapper>
                </Col>
              </Row>
              <SubFLex column gap="25px">
                <TrainingSection studentDetails={studentData} pendingData={pendingData} />
              </SubFLex>

              <StyledDivider />

              {/* Work Experience */}
              <Row ref={workexp}>
                <Col span={20}>
                  <MainHeading>Work Experience</MainHeading>
                </Col>
                <Col span={4}>
                  <EditIconWrapper onClick={() => setWorkExpDrawer(true)}>
                    <EditIcon />
                  </EditIconWrapper>
                </Col>
              </Row>
              <SubFLex column gap="25px">
                <WorkExpSection promotionData={studentData} pendingData={pendingData} />
              </SubFLex>

              <StyledDivider />

              {/* Awards */}
              <Row ref={award}>
                <Col span={20}>
                  <MainHeading>Awards & Recognition</MainHeading>
                </Col>
                <Col span={4}>
                  <EditIconWrapper onClick={() => setAwardsDrawer(true)}>
                    <EditIcon />
                  </EditIconWrapper>
                </Col>
              </Row>
              <SubFLex column gap="25px">
                <AwardsSection studentDetails={studentData} />
              </SubFLex>
            </LeftCol>

            {/* Right Sidebar */}
            <Col span={8}>
              <RightDiv>
                {!studentData?.student?.isExpCandidate && (
                  <>
                    <CurrentlyPursuing
                      studentDetails={studentData}
                      instituteName={instituteName}
                    />
                    <StyledDivider />
                  </>
                )}

                <Row>
                  <Col span={20}>
                    <MainHeading>Additional Information</MainHeading>
                  </Col>
                  <Col span={4}>
                    <EditIconWrapper onClick={() => setAdditionalInfoDrawer(true)}>
                      <EditIcon />
                    </EditIconWrapper>
                  </Col>
                </Row>
                <AdditionalInfo studentDetails={studentData} pendingData={pendingData} />

                <StyledDivider />

                <Row>
                  <Col span={20}>
                    <MainHeading>Social Media Links</MainHeading>
                  </Col>
                  <Col span={4}>
                    <EditIconWrapper onClick={() => setSocialMediaDrawer(true)}>
                      <EditIcon />
                    </EditIconWrapper>
                  </Col>
                </Row>
                <SocialMediaLinks studentDetails={studentData} />

                <StyledDivider />

                <Row>
                  <Col span={20}>
                    <MainHeading>Resume</MainHeading>
                  </Col>
                  <Col span={4}>
                    <GeneralEditIcon>
                      <SetDefaultPill onClick={() => setDefaultDrawer(true)}>
                        Set Default
                      </SetDefaultPill>
                    </GeneralEditIcon>
                  </Col>
                </Row>
                <ResumeSection
                  resumeFiles={resumeFiles}
                  handleResumeUpload={handleResumeUpload}
                  loading={loadingResumes}
                  deleteResumeFile={deleteResumeFile}
                  downloadResumeFile={downloadResumeFile}
                  systemResumeStudentData={studentData}
                  resumeError={resumeError}
                  defaultResumeId={defaultResumeId}
                  onOpenUploadDrawer={() => setUploadDrawer(true)}
                  studentUpdateAt={studentData?.updateAt}
                />
              </RightDiv>
            </Col>
          </RowwithPadding>
        </OuterDiv>
      </SectionWrapper>

      {/* Project Drawer */}
      {projectDrawer && (
        <ProjectDrawer
          drawerStatus={projectDrawer}
          setdrawerStatus={setProjectDrawer}
          studentFormData={studentData}
          pendingData={pendingData}
          updateStudentData={(payload) => dispatch(updateStudentData(payload))}
          getPendingData={fetchData}
          instituteName={instituteName}
          studentId={studentId}
        />
      )}

      {/* Education Drawer */}
      {educationDrawer && (
        <EducationalDrawer
          drawerStatus={educationDrawer}
          setdrawerStatus={setEducationDrawer}
          studentFormData={studentData}
          pendingData={studentPendingData}
          updateStudentData={(payload) => dispatch(updateStudentData(payload))}
          getPendingData={fetchData}
          instituteName={instituteName}
          studentId={studentId}
          deleteEducation={() => { }}
          deleteFile={() => { }}
          countryList={[]}
          stateList={[]}
          getListOfCountries={handleGetListOfCountries}
          getListOfState={handleGetListOfState}
          getListOfCity={handleGetListOfCity}
          getListOfSkills={() => { }}
          degreeList={[]}
          listOfStudentSkills={[]}
          searchAPI={handleSearchAPI}
        />
      )}

      {/* Additional Info Drawer */}
      {additionalInfoDrawer && (
        <AdditionDrawer
          drawerStatus={additionalInfoDrawer}
          setdrawerStatus={setAdditionalInfoDrawer}
          studentFormData={studentData}
          pendingData={pendingData}
          updateStudentData={(payload) => dispatch(updateStudentData(payload))}
          getPendingData={fetchData}
          studentId={studentId}
          countryList={countryList}
          getListOfCountries={handleGetListOfCountries}
          getListOfState={handleGetListOfState}
          getListOfCity={handleGetListOfCity}
          getCities={getCities}
        />
      )}

      {/* Awards Drawer */}
      {awardsDrawer && (
        <AwardsDrawer
          drawerStatus={awardsDrawer}
          setdrawerStatus={setAwardsDrawer}
          studentFormData={studentData}
          pendingData={pendingData}
          updateStudentData={(payload) => dispatch(updateStudentData(payload))}
          getPendingData={fetchData}
          studentId={studentId}
        />
      )}

      {/* Internship Drawer */}
      {internshipDrawer && (
        <InternshipDrawer
          drawerStatus={internshipDrawer}
          setdrawerStatus={setInternshipDrawer}
          studentFormData={studentData}
          pendingData={pendingData}
          updateStudentData={(payload) => dispatch(updateStudentData(payload))}
          getPendingData={fetchData}
          instituteName={instituteName}
          studentId={studentId}
        />
      )}

      {/* Training Drawer - Uses CourseTrainingDrawer */}
      {trainingDrawer && (
        <CourseTrainingDrawer
          drawerStatus={trainingDrawer}
          setdrawerStatus={setTrainingDrawer}
          studentFormData={studentData}
          pendingData={pendingData}
          updateStudentData={(payload) => dispatch(updateStudentData(payload))}
          getPendingData={fetchData}
          listOfStudentSkills={[]}
          getListOfSkills={() => { }}
          studentId={studentId}
        />
      )}

      {/* Work Experience Drawer */}
      {workExpDrawer && (
        <WorkExperienceDrawer
          drawerStatus={workExpDrawer}
          setdrawerStatus={setWorkExpDrawer}
          studentFormData={studentData}
          pendingData={pendingData}
          updateStudentData={(payload) => dispatch(updateStudentData(payload))}
          getPendingData={fetchData}
          instituteName={instituteName}
          studentId={studentId}
          listOfStudentSkills={[]}
          setRoleDrawer={() => { }}
          itemId={null}
          setLoading={() => { }}
          roleDrawer={false}
          getEligibleDetails={() => { }}
          getRoleFloatDetails={() => { }}
          setExpDrawer={() => { }}
          expDrawer={false}
          getListOfSkills={() => { }}
        />
      )}

      {/* Social Media Drawer */}
      {socialMediaDrawer && (
        <SocialMediaDrawer
          drawerStatus={socialMediaDrawer}
          setdrawerStatus={setSocialMediaDrawer}
          studentFormData={studentData}
          updateStudentData={(payload) => dispatch(updateStudentData(payload))}
          studentId={studentId}
          getPendingData={fetchData}
        />
      )}

      {objectiveDrawer && (
        <ObjectiveDrawer
          drawerStatus={objectiveDrawer}
          setdrawerStatus={setObjectiveDrawer}
          studentFormData={studentData}
          updateStudentData={(payload) => dispatch(updateStudentData(payload))}
          studentId={studentId}
          getPendingData={fetchData}
        />
      )}

      {defaultDrawer && (
        <DefaultResumeDrawer
          drawerStatus={defaultDrawer}
          setDrawerStatus={setDefaultDrawer}
          resumeFiles={resumeFiles}
          defaultId={defaultResumeId}
          onSetDefault={handleSetDefaultResume}
          getStudentResumeData={(id) => dispatch(getStudentResumeData(id))}
          studentId={studentId}
          onDeleteResume={deleteResumeFile}
          studentUpdateAt={studentData?.updateAt}
          getPendingData={fetchData}
          pendingData={pendingData}
        />
      )}

      {uploadDrawer && (
        <UploadResumeDrawer
          drawerStatus={uploadDrawer}
          setDrawerStatus={setUploadDrawer}
          resumeFiles={resumeFiles}
          defaultId={defaultResumeId}
          onSave={handleUploadDrawerSave}
          getStudentResumeData={(id) => dispatch(getStudentResumeData(id))}
          studentId={studentId}
          studentUpdateAt={studentData?.updateAt}
          studentDetails={studentData}
          getPendingData={fetchData}
          pendingData={pendingData}
        />
      )}
    </>
  )
}

export default StudentResume
